import React, { useEffect, useState } from "react";
import Header from "./Header";
import AppList from "./AppList";
import HomeHeader from "./HomeHeader";

const Products = () => {
  const access = localStorage.getItem("accessToken");
  const [loading, setLoading] = useState(true);

  console.log("Access Token:", access); // Optional: check if token is retrieved

  return (
    <div>
      <div>
        {access ? <Header /> : <HomeHeader />}
        <AppList />
      </div>
    </div>
  );
};

export default Products;
